const KEY = "booking_state_v1";

export function getBooking() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function setBooking(patch) {
  const cur = getBooking();
  const next = { ...cur, ...patch };
  sessionStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function clearBooking() {
  sessionStorage.removeItem(KEY);
}